<script>
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import {useStore} from "vuex";
import Swals from "@/assets/js/Swals";


export default {
  name: "ProfilePage",
  components: {BottomNavigation},

  setup() {

    let store = useStore()

    function log_out() {

      Swals.Question('آیا از حساب کاربری خود خارج میشوید؟' , 'خروج از حساب').then((res)=>{

        if (res.isConfirmed){
          store.commit('EmptyBasket')
          store.commit('empty_state')
          localStorage.clear()
          window.location.href = '/'
        }

      })

    }


    return {

log_out,

    }
  }
}
</script>


<template>


  <div id="main" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">کاربری</p>
        <router-link :to="{name:'HomePage'}">
        <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body w-100 animate__animated animate__fadeIn">

      <router-link :to="{name:'MyProfile'}"
                   class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/user.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">پروفایل من</p>
      </router-link>

      <router-link :to="{name:'WalletPage'}"
                   class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/wallet.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">کیف پول و سابقه پرداخت ها</p>
      </router-link>

      <router-link :to="{name:'MarksProducts'}" class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/mark.png" style="height:25px">
        <p class="mr-3 font-4 font-bold font-color">نشان شده ها</p>
      </router-link>

      <router-link :to="{name:'MyAuctions'}" class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/hammer.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">مزایده های شرکت شده</p>
      </router-link>

      <router-link :to="{name:'OffersPage'}" class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/search.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">ثبت پیشنهاد خرید</p>
      </router-link>

      <router-link :to="{name:'WebPage' , params:{type:'ویدئو های آموزشی'}}" class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/play.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">ویدئو های آموزشی</p>
      </router-link>

      <router-link :to="{name:'WebPage' , params:{type:'وبلاگ'}}" class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/weblag.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">وبلاگ</p>
      </router-link>

      <a href="https://market-app.ir/rules?action=rules" target="_blank" class="mt-3 text-decoration-none shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/rulls.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">قوانین و مقررات</p>
      </a>

      <a href="https://market-app.ir/rules?action=about" target="_blank" class="mt-3 text-decoration-none shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/aboutus.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">درباره ما</p>
      </a>

      <router-link :to="{name:'SupportPage'}" class="text-decoration-none mt-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/chatting.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">ارتباط با پشتیبانی</p>
      </router-link>

      <div @click="log_out" class="my-3 shadow-custom bg-white font-4 rounded-4 w-100 p-3 d-flex align-items-center">
        <img src="../assets/img/enter.png" style="width: 25px;height:25px">
        <p class="mr-3 font-4 font-bold font-color">خروج از اپلیکیشن</p>
      </div>

    </div>

    <BottomNavigation></BottomNavigation>

  </div>

</template>


<style scoped>

</style>